module.exports = __webpack_public_path__ + "static/media/q_gray.bf247a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/q_gray.png
// module id = 709
// module chunks = 0